import React from 'react';
import {Switch, Route } from 'react-router-dom';
import HomeContainer from "../HomeContainer/HomeContainer";
import AboutComponent from "../About/about";
import ProjectContainer from "../Projects/projects";
import ContactContainer from "../Contact/contact";
import ServiceContainer from "../Services/service";
import AppLayout from '../App';

const Routes = () =>{
    return (
        <AppLayout>
            <Switch>
                <Route path="/" exact component={HomeContainer}></Route>
                <Route path="/about" exact component={AboutComponent}></Route>
                <Route path="/projects" exact component={ProjectContainer}></Route>
                <Route path="/contact" exact component={ContactContainer}></Route>
                <Route path="/services" exact component={ServiceContainer}></Route>
            </Switch>
        </AppLayout>
    )
};

export default  Routes;